import { render, staticRenderFns } from "./FormFieldPhone.vue?vue&type=template&id=dd06b5d6&scoped=true&"
import script from "./FormFieldPhone.vue?vue&type=script&lang=js&"
export * from "./FormFieldPhone.vue?vue&type=script&lang=js&"
import style0 from "./FormFieldPhone.vue?vue&type=style&index=0&id=dd06b5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06b5d6",
  null
  
)

export default component.exports